/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { ExceptionResponseDTO } from '../model/exception-response-dto';
// @ts-ignore
import { GetProfiloServizio409Response } from '../model/get-profilo-servizio409-response';
// @ts-ignore
import { GetProfiloServizio422Response } from '../model/get-profilo-servizio422-response';
// @ts-ignore
import { PraticaEsercenteEligibilitaDTO } from '../model/pratica-esercente-eligibilita-dto';
// @ts-ignore
import { PraticaEsercentePerContoForm } from '../model/pratica-esercente-per-conto-form';
// @ts-ignore
import { PraticaEsercenteSubmitResponseDTO } from '../model/pratica-esercente-submit-response-dto';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    GestioneDomandeEsercentePerContoDellesercenteServiceInterface,
    EligibilitaPraticaEsercentePerContoRequestParams,
    SubmitPraticaEsercentePerContoRequestParams
} from './gestione-domande-esercente-per-conto-dellesercente.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class GestioneDomandeEsercentePerContoDellesercenteService extends BaseService implements GestioneDomandeEsercentePerContoDellesercenteServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Eleggibilita\&#39; dell\&#39;esercente scelto a presentare domanda su questo bando.
     * Stesso esito del self-service (can_submit, reason, domanda_esistente_*), calcolato sul profilo indicato in profilo_esercente_id (non sul chiamante). checkTipoPratica GESTIONE. 404 se il profilo e\&#39; fuori dal perimetro del chiamante o il bando non e\&#39; raggiungibile dal canale operatore (flag di policy spento, modulo esercenti off, tipologia non ammessa). Un esercente bloccato dall\&#39;amministrazione non puo\&#39; ricevere domande: can_submit&#x3D;false con reason esercente_bloccato.
     * @endpoint get /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/per-esercente/eligibilita
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public eligibilitaPraticaEsercentePerConto(requestParameters: EligibilitaPraticaEsercentePerContoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PraticaEsercenteEligibilitaDTO>;
    public eligibilitaPraticaEsercentePerConto(requestParameters: EligibilitaPraticaEsercentePerContoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PraticaEsercenteEligibilitaDTO>>;
    public eligibilitaPraticaEsercentePerConto(requestParameters: EligibilitaPraticaEsercentePerContoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PraticaEsercenteEligibilitaDTO>>;
    public eligibilitaPraticaEsercentePerConto(requestParameters: EligibilitaPraticaEsercentePerContoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling eligibilitaPraticaEsercentePerConto.');
        }
        const profiloEsercenteId = requestParameters?.profiloEsercenteId;
        if (profiloEsercenteId === null || profiloEsercenteId === undefined) {
            throw new Error('Required parameter profiloEsercenteId was null or undefined when calling eligibilitaPraticaEsercentePerConto.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'profilo_esercente_id',
            <any>profiloEsercenteId,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pratiche-esercente/per-esercente/eligibilita`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PraticaEsercenteEligibilitaDTO>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Presenta una domanda esercente per conto dell\&#39;esercente.
     * Multipart: part \&#39;pratica\&#39; (JSON {profilo_esercente_id, form_data, negozi_ids, da_pratica_esercente_id?, allegati_da_copiare?[{chiave, id_allegato}]}) + N part \&#39;allegato_&lt;chiave&gt;\&#39; (un upload esplicito vince sulla copia della stessa chiave). La domanda nasce SOTTOMESSA con l\&#39;operatore come inseritore, evento di creazione con attore OPERATORE e avviso email all\&#39;esercente dopo il commit. checkTipoPratica GESTIONE. Response 201: {id, codice_pratica, stato_richiesta}. 404 profilo fuori perimetro / bando non raggiungibile dal canale operatore / domanda sorgente o allegato da copiare non dello stesso profilo o di un bando non consultabile dal chiamante; 409 stato del bando non partecipabile o domanda attiva gia\&#39; presente; 422 validazione form, nessun negozio, allegato non copiabile (documento di sistema/convenzione) o su un campo diverso, MIME o dimensione di un allegato copiato non ammessi dal campo del bando, esercente bloccato dall\&#39;amministrazione (esercente_bloccato).
     * @endpoint post /api/v1/gestione/tipi-pratica/{id_tipo_pratica}/pratiche-esercente/per-esercente
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public submitPraticaEsercentePerConto(requestParameters: SubmitPraticaEsercentePerContoRequestParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PraticaEsercenteSubmitResponseDTO>;
    public submitPraticaEsercentePerConto(requestParameters: SubmitPraticaEsercentePerContoRequestParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PraticaEsercenteSubmitResponseDTO>>;
    public submitPraticaEsercentePerConto(requestParameters: SubmitPraticaEsercentePerContoRequestParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PraticaEsercenteSubmitResponseDTO>>;
    public submitPraticaEsercentePerConto(requestParameters: SubmitPraticaEsercentePerContoRequestParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        const idTipoPratica = requestParameters?.idTipoPratica;
        if (idTipoPratica === null || idTipoPratica === undefined) {
            throw new Error('Required parameter idTipoPratica was null or undefined when calling submitPraticaEsercentePerConto.');
        }
        const allParts = requestParameters?.allParts;
        if (allParts === null || allParts === undefined) {
            throw new Error('Required parameter allParts was null or undefined when calling submitPraticaEsercentePerConto.');
        }
        const pratica = requestParameters?.pratica;
        if (pratica === null || pratica === undefined) {
            throw new Error('Required parameter pratica was null or undefined when calling submitPraticaEsercentePerConto.');
        }

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'allParts',
            <any>allParts,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        // authentication (bearer-token) required
        localVarHeaders = this.configuration.addCredentialToHeaders('bearer-token', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let localVarFormParams: { append(param: string, value: any): any; };
        let localVarUseForm = false;
        let localVarConvertFormParamsToString = false;
        if (localVarUseForm) {
            localVarFormParams = new FormData();
        } else {
            localVarFormParams = new HttpParams({encoder: this.encoder});
        }

        if (pratica !== undefined) {
            localVarFormParams = localVarFormParams.append('pratica', localVarUseForm ? new Blob([JSON.stringify(pratica)], {type: 'application/json'}) : <any>pratica) as any || localVarFormParams;
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/v1/gestione/tipi-pratica/${this.configuration.encodeParam({name: "idTipoPratica", value: idTipoPratica, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/pratiche-esercente/per-esercente`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PraticaEsercenteSubmitResponseDTO>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: localVarConvertFormParamsToString ? localVarFormParams.toString() : localVarFormParams,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
